import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { Ad } from "@dto/Ad";
import { adApi } from "@store/services/ad";
import { selectSelectedCategories } from "@store/menuItem/menuItemReducer";

export interface MapState {
  ads: Ad[];
  lastImpressionIndex: number;
}

const initialState: MapState = {
  ads: [],
  lastImpressionIndex: -1,
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setAdsAction: (state: MapState, action: PayloadAction<Ad[]>) => {
      state.ads = action.payload;
    },
    setLastImpression: (state: MapState, action: PayloadAction<Ad>) => {
      const index = state.ads.findIndex((ad) => ad.id === action.payload.id);
      state.lastImpressionIndex = index;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      adApi.endpoints.getAds.matchFulfilled,
      (state, action) => {
        state.ads = action.payload;
      },
    );
  },
});

// Selectors
export const selectAds = (state: RootState) => {
  return state.ad.ads;
};

export const selectFilteredAds = createSelector(
  selectAds,
  selectSelectedCategories,
  (ads, selectedCategories) => {
    return ads.filter((ad) => {
      const result = selectedCategories.some((category) => {
        return ad.categoryIds.includes(category.id);
      });

      return result;
    });
  },
);

export const selectLastImpressionIndex = (state: RootState) => {
  return state.ad.lastImpressionIndex;
};

export const { setAdsAction, setLastImpression } = mapSlice.actions;

// eslint-disable-next-line import/no-default-export
export default mapSlice.reducer;
